import { render, staticRenderFns } from "./DashboardDetailFinishedNg.vue?vue&type=template&id=8b611422&scoped=true&"
import script from "./DashboardDetailFinishedNg.vue?vue&type=script&lang=js&"
export * from "./DashboardDetailFinishedNg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b611422",
  null
  
)

export default component.exports